export const CloudflareAiIconUrl =
  "https://developers.cloudflare.com/favicon.png";
